import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ProgressBar } from 'react-bootstrap';

export default class StrengthIndicator extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    score: PropTypes.number,
    strength: PropTypes.array,
    thresholds: PropTypes.array,
  };

  static defaultProps = {
    strength: [
      {
        text: 'Weak',
        style: 'danger',
      },
      {
        text: 'Good',
        style: 'warning',
      },
      {
        text: 'Strong',
        style: 'success',
      },
    ],
    thresholds: [10, 30, 50],
  };

  constructor(props) {
    super(props);

    this.state = {
      score: props.score ? props.score : 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (!this.props.score && prevProps.text !== this.props.text) {
      this.handleInputChange();
    }
  }

  handleInputChange() {
    if (this.props.text === '') {
      return this.setState({ score: 0 });
    }

    this.props.thresholds.some((count, key, thresholds) => {
      if (count > this.props.text.length) {
        this.setState({ score: key === 0 ? 0 : key - 1 });

        return true;
      }

      if (typeof thresholds[key + 1] === 'undefined') {
        this.setState({ score: key });
      }

      return false;
    });
  }

  render() {
    const { score } = this.state;
    const { strength } = this.props;

    return (
      <ProgressBar
        {...this.props}
        bsStyle={strength[score].style}
        max={strength.length}
        now={score + 1}
        label={strength[score].text}
      />
    );
  }
}
